import { useEffect, useRef } from "react";
import { useAppContext } from "context/app-context";
import { getCookie } from "services/cookies";
import { COOKIES } from "constants/cookies";
import {
  identifyZendeskUser,
  loadZendeskSnippet,
  logoutZendeskUser
} from "services/zendeskMessenger";

export const ZendeskProvider = () => {
  const { sessionInfo } = useAppContext();
  const wasLoggedInRef = useRef(false);
  const widgetKey = getCookie(COOKIES.REACT_APP_ZENDESK_WIDGET_KEY);

  useEffect(() => {
    if (!widgetKey || sessionInfo?.isInitialLoading) return undefined;

    let cancelled = false;

    loadZendeskSnippet(widgetKey)
      .then(() => {
        if (cancelled || !window.zE) return;
        if (sessionInfo.isLoggedIn) {
          identifyZendeskUser({
            conversationTags: ["raise_logged_in", "gcx"]
          });
          wasLoggedInRef.current = true;
          return;
        }
        logoutZendeskUser();
        wasLoggedInRef.current = false;
      })
      .catch((error) => {
        console.error("Error loading Zendesk script:", error);
      });

    return () => {
      cancelled = true;
    };
  }, [sessionInfo?.isLoggedIn, sessionInfo?.isInitialLoading, widgetKey]);

  return null;
};
